import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

// 用户类型定义 - 与后端 UserResponse 对齐
interface User {
  id?: number; // 可选，因为某些接口不返回 id
  email: string;
  full_name?: string | null;
  avatar?: string | null;
  subscription_plan?: string;
  auth_provider?: string;
  is_verified?: boolean;
  is_sso?: boolean;
  is_first_login?: boolean;
  created_at?: string;
  last_active_at?: string | null;
  // 用户偏好设置（从 ProfileResponse.preferences 获取）
  preferences?: {
    theme: 'light' | 'dark' | 'system';
    language: 'en' | 'fr';
    notification_enabled: boolean;
    share_usage_data: boolean;
  };
}

interface UserState {
  user: User | null;
  token: string;
  refreshToken: string;
  num: number;
  addNum: () => void;
  setUser: (user: User | null) => void;
  setToken: (token: string) => void;
  setRefreshToken: (refreshToken: string) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  clearAuth: () => void;
  // 更新用户偏好设置
  updatePreferences: (preferences: Partial<User['preferences']>) => void;
}

// 定义 Store
export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      token: '',
      refreshToken: '',
      num: 0,
      addNum: () => set((state) => ({ num: state.num + 1 })),
      setUser: (user) => set({ user }),
      setToken: (token) => set({ token }),
      setRefreshToken: (refreshToken) => set({ refreshToken }),
      setTokens: (accessToken, refreshToken) => set({ token: accessToken, refreshToken }),
      clearAuth: () => set({ user: null, token: '', refreshToken: '' }),
      // 更新用户偏好设置
      updatePreferences: (preferences) =>
        set((state) => ({
          user: state.user
            ? {
                ...state.user,
                preferences: { ...state.user.preferences, ...preferences } as User['preferences'],
              }
            : null,
        })),
    }),
    {
      name: 'userStore',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
